import React from "react"
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"
import Layout from "../components/common/layout"
import Poster from "../images/aboutUs/poster.png"
import Play from "../images/aboutUs/play.svg"
import BiIllustation from "../images/ourApproach/BI-illustration.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"
import Fade from "react-reveal/Fade"
import Rotate from "react-reveal/Rotate"
import Facebook from "../images/ourApproach/fb.svg"
import Verizon from "../images/ourApproach/verizon.svg"
import Twitter from "../images/ourApproach/twitter.svg"
import GoogleAdWords from "../images/ourApproach/adwords.svg"
import AppleSearch from "../images/ourApproach/applesearch.svg"
import Pintrest from "../images/ourApproach/pintrest.svg"
import Snap from "../images/ourApproach/Snap.svg"
import Reddit from "../images/ourApproach/reddit.svg"
import YouTube from "../images/ourApproach/youtube.svg"
import Quora from "../images/ourApproach/quora.svg"
import Instagram from "../images/ourApproach/insta.svg"
import Amazon from "../images/ourApproach/amazon.svg"
import Bing from "../images/ourApproach/bing.svg"
import Yahoo from "../images/ourApproach/yahoo.svg"
import Zoom from "react-reveal/Zoom"
import ContactForm from "../components/common/contact-form"
const OurApproach = ({ data }) => {
    const findGroup = (data, groupName) => data.allGhostPost.group.find(findGroup => findGroup.fieldValue === groupName ? true : false
    )
    const header = findGroup(data, `header`).edges
    const footer = findGroup(data, `footer`).edges
    return (
        <Layout header={header} footer={footer}>
            <Helmet>
                <title>Our approach</title>
            </Helmet>
            <section className="home-approach home">
                {findGroup(data, `HowOur`).edges.map(item => (
                    <div dangerouslySetInnerHTML={{ __html: item.node.html }} />
                ))}
                <div className="home-approach__video">
                    <video
                        muted
                        width="100%"
                        height="100%"
                        poster={Poster}
                        id="video"
                    >
                        <source src="#" />
                    </video>
                    <div className="video__controls">
                        <button id="btn-replay">
                            <img src={Play} alt="Play" />
                        </button>
                    </div>
                </div>
                <div className="approach__next-page">
                    <button className="next-page__btn">
                        <FontAwesomeIcon icon={faChevronDown} />
                    </button>
                </div>
            </section>
            <section className="our-capabilities">
                <div className="container">
                    <h2>Meet Our Media, Creative, & Tech Capabilities</h2>
                    <div className="our-capabilities__media">
                        <div className="our-capabilities__media-left">
                            <Fade bottom>
                                <h3>
                                    {
                                        findGroup(data, `MediaExecution`)
                                            .edges[0].node.title
                                    }
                                </h3>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: findGroup(
                                            data,
                                            `MediaExecution`
                                        ).edges[0].node.html,
                                    }}
                                />
                            </Fade>
                            <Fade left delay={300}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: findGroup(data, `OurWinning`)
                                            .edges[0].node.html,
                                    }}
                                />
                            </Fade>
                        </div>
                        <div className="our-capabilities__media-right">
                            <ul>
                                <Zoom bottom>
                                    <li>
                                        <div className="our-capabilities__logo">
                                            <img
                                                src={Facebook}
                                                alt="Facebook"
                                            />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li>
                                        <div className="our-capabilities__logo">
                                            <img src={Verizon} alt="Verizon" />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li>
                                        <div className="our-capabilities__logo">
                                            <img src={Twitter} alt="Twitter" />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img
                                                src={GoogleAdWords}
                                                alt="Google AdWords"
                                            />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img
                                                src={AppleSearch}
                                                alt="Apple Search"
                                            />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img
                                                src={Pintrest}
                                                alt="Pintrest"
                                            />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img src={Snap} alt="Snap" />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img src={YouTube} alt="YouTube" />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img src={Reddit} alt="Reddit" />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img src={Quora} alt="Quora" />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img
                                                src={Instagram}
                                                alt="Instagram"
                                            />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img src={Amazon} alt="Amazon" />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img src={Bing} alt="Bing" />
                                        </div>
                                    </li>
                                </Zoom>
                                <Zoom bottom>
                                    <li className="our-capabilities__logo">
                                        <div className="our-capabilities__logo">
                                            <img src={Yahoo} alt="Yahoo" />
                                        </div>
                                    </li>
                                </Zoom>
                            </ul>
                        </div>
                    </div>
                    <div
                        className="our-capabilities__scale"
                        dangerouslySetInnerHTML={{
                            __html: findGroup(data, `Scale`).edges[0].node.html,
                        }}
                    />
                    <div className="our-capabilities__btn">
                        <button>Get High Performing Ads</button>
                    </div>
                </div>
            </section>
            <section className="production">
                <div className="border" />
                <div className="container">
                    {findGroup(data, `CreativeProduction`).edges.map(item => (
                        <div className="production__title">
                            <h2>{item.node.title}</h2>
                            <div
                                className="production__subtitle"
                                dangerouslySetInnerHTML={{
                                    __html: item.node.html,
                                }}
                            />
                        </div>
                    ))}
                    {findGroup(data, `Production`).edges.map(item => (
                        <div className="production__item">
                            <div className="left">
                                <Fade>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: item.node.html,
                                        }}
                                    />
                                </Fade>
                            </div>
                            <div className="right">
                                <Rotate top right delay={200}>
                                    <img
                                        src={item.node.feature_image}
                                        alt="Multi-Variant Creative"
                                    />
                                </Rotate>
                            </div>
                        </div>
                    ))}
                    <div className="production__btn">
                        <button>Get High Performing Ads</button>
                    </div>
                </div>
            </section>
            <section className="reporting">
                <div className="container">
                    <div
                        className="reporting__title"
                        dangerouslySetInnerHTML={{
                            __html: findGroup(data, `ReportingBlock`).edges[0]
                                .node.html,
                        }}
                    />
                    <div className="reporting__img">
                        <img
                            src={BiIllustation}
                            alt="Business Intellegence Reporting"
                        />
                    </div>
                    <div
                        className="reporting__items"
                        dangerouslySetInnerHTML={{
                            __html: findGroup(data, `Reporting`).edges[0].node
                                .html,
                        }}
                    />
                    <div className="reporting__btn">
                        <button>See How It Works</button>
                    </div>
                </div>
            </section>
            <section className="feedback feedback-aboutUs">
                <div className="container">
                    <h2>Hyperscale Your Revenue</h2>
                    <ContactForm firstName lastName company email />
                </div>
            </section>
        </Layout>
    )
}
export const ourApproachQuery = graphql`
    query GhostOurApproachQuery {
        allGhostPost(
            filter: {
                tags: {
                    elemMatch: {
                        name: { in: ["OurApproach", "header", "footer"] }
                    }
                }
            }
        ) {
            group(field: tags___name) {
                fieldValue
                edges {
                    node {
                        id
                        html
                        slug
                        title
                        ghostId
                        tags {
                            name
                        }
                        children {
                            id
                        }
                        custom_excerpt
                        excerpt
                        feature_image
                    }
                }
            }
        }
    }
`
export default OurApproach
